<section class="col-12 col-xs-12 col-sm-7 col-md-8 left-section sanofi-customTabs">
  <div>
    <div class="d-flex justify-content-between">
      <h3 class="c-heading c-heading-h2 mb-0">{{ 'accountOverview.tabTitle' + active | cxTranslate }}</h3>
      <nav ngbNav #nav="ngbNav" class="sanofi-customTabs__navigationTabs" [(activeId)]="active" (navChange)="onNavChange($event)">
        <ng-container [ngbNavItem]="AccountOverviewTabs.INVOICES" [disabled]="active === AccountOverviewTabs.INVOICES">
          <button ngbNavLink>{{ 'makeAPayment.invoicesTabLabel' | cxTranslate }}</button>
          <ng-template ngbNavContent>
            <app-invoices-list [paymentList]="paymentList()" [isLoading]="invoicesLoading" [isCompactView]="true"/>
            @if (paymentList().length) {
              <sanofi-go-to-make-payment-page-button [translation]="'accountOverview.Financials.button_txt' | cxTranslate"/>
            }
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="AccountOverviewTabs.CREDITS" [disabled]="active === AccountOverviewTabs.CREDITS">
          <button ngbNavLink>{{ 'makeAPayment.credits_title' | cxTranslate }}</button>
          <ng-template ngbNavContent>
            <app-credits-list [creditList]="creditList()" [isLoading]="invoicesLoading" [isCompactView]="true"/>
            @if (creditList().length) {
              <sanofi-go-to-make-payment-page-button [translation]="'accountOverview.Financials.credits.credit_btn_txt' | cxTranslate"/>
            }
          </ng-template>
        </ng-container>
        <ng-container [ngbNavItem]="AccountOverviewTabs.ORDERS" [disabled]="active === AccountOverviewTabs.ORDERS">
          <button ngbNavLink>{{ 'accountOverview.ordersTabText' | cxTranslate }}</button>
          <ng-template ngbNavContent>
            <sanofi-orders-table [orders]="ordersList()" [isCompactView]="true" [isLoading]="ordersLoading"/>
            @if (ordersList().length && !ordersLoading) {
              <div class="invoice-btngrps">
                <button type="button" class="c-button c-button--link c-button--link-primary-lg" data-di-id="di-id-41a05d18-6b04a424"
                        [routerLink]="['/my-account/orders']"
                >
                  {{ 'accountOrders.button_text' | cxTranslate }}
                </button>
              </div>
            }
          </ng-template>
        </ng-container>

        <ng-container [ngbNavItem]="AccountOverviewTabs.STATEMENTS" [disabled]="active === AccountOverviewTabs.STATEMENTS">
          <button ngbNavLink>{{ 'accountOverview.tabTitleStatements' | cxTranslate }}</button>
          <ng-template ngbNavContent>
            <section class="mt-4">
              <app-open-statements [hideAside]="true" [restrictToTen]="true" [widgetView]="true" (statements)="onStatements($event)"/>

              @if (statementsLoaded()) {
                <div class="invoice-btngrps">
                  <button type="button"
                          class="c-button c-button--link c-button--link-primary-lg pl-0"
                          data-di-id="di-id-41a05d18-6b04a424"
                          [routerLink]="['/my-account/reports']"
                          [queryParams]="{ statementsTab: true }"
                  >
                    {{ 'statements.viewStatementsBtn' | cxTranslate }}
                  </button>
                </div>
              }
            </section>
          </ng-template>
        </ng-container>
      </nav>
    </div>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>


  <div class="c-widget c-widget--no-borders d-flex d-sm-none">
    <h3 class="c-widget-title c-heading c-heading-h2">{{ "accountOverview.myAccount_label" | cxTranslate }}</h3>
    <div class="c-widget-divider"></div>
    <div class="d-flex justify-content-between">
      <div class="c-widget--my-account-description">
        {{ "accountOverview.account_label" | cxTranslate }} &nbsp;
        <strong>{{ accountNumber }}</strong>
      </div>
      <div>
        <a
          class="c-link"
          data-di-id="di-id-9b8eeaed-3b366785"
          href="javascript:;"
          (click)="navigateToAccountDetails()"
        >
          {{ "accountOverview.view_label" | cxTranslate }}
        </a>
      </div>
    </div>
  </div>
</section>
